var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12.8333C22.5 17.8959 18.3959 22 13.3333 22C8.27072 22 4.16667 17.8959 4.16667 12.8333C4.16667 7.77072 8.27072 3.66667 13.3333 3.66667C18.3959 3.66667 22.5 7.77072 22.5 12.8333ZM21.0336 23.1007C18.8887 24.7119 16.2225 25.6667 13.3333 25.6667C6.24568 25.6667 0.5 19.921 0.5 12.8333C0.5 5.74568 6.24568 0 13.3333 0C20.421 0 26.1667 5.74568 26.1667 12.8333C26.1667 15.7225 25.2119 18.3887 23.6007 20.5336C23.6689 20.5849 23.7343 20.6416 23.7964 20.7036L32.963 29.8703C33.679 30.5863 33.679 31.7471 32.963 32.463C32.2471 33.179 31.0863 33.179 30.3703 32.463L21.2036 23.2964C21.1416 23.2343 21.0849 23.1689 21.0336 23.1007Z",
    fill: "#1D2933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f4552994998f5ad32f6ee1691b5e1280.svg";
export { ForwardRef as ReactComponent };